// extracted by mini-css-extract-plugin
export default {"products":"zv-z","card":"Av-z","oosMessaging":"Bv-z"};